// Import model
import { NumberField } from '../models/NumberField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for NumberField - handles JSON serialization and deserialization with type validation
 */
export class NumberFieldSerializer {
  /**
   * Deserializes a JSON string into a NumberField instance
   */
  static deserialize(json: string): NumberField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a NumberField instance
   */
  static fromObject(obj: any): NumberField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to NumberField');
    }


    const instance: NumberField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      dcf93Fdd: obj['_dcf93fdd'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of NumberField instances
   */
  static deserializeArray(json: string): NumberField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a NumberField instance to a JSON string
   */
  static serialize(instance: NumberField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a NumberField instance to a plain object
   */
  static toObject(instance: NumberField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_dcf93fdd': instance.dcf93Fdd,
    };
  }

  /**
   * Serializes an array of NumberField instances to a JSON string
   */
  static serializeArray(instances: NumberField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
